export const LOCAL_STORAGE = {
  USER_DETAILS: "user_details" as const,
};

export const COOKIE_STORAGE = {
  TOKEN: "token" as const,
};
